import React from 'react'
import LuxPlusPromoCardCarousel from './LuxPlusPromoCardCarousel'
import LuxPlusMemberLandingLayout from './LuxPlusMemberLandingLayout'
import { useLuxPlusPromoCards } from 'luxPlus/hooks/useLuxPlusPromos'

function LuxPlusLoggedInLandingPageContent() {
  const promos = useLuxPlusPromoCards()

  return (
    <LuxPlusMemberLandingLayout>
      {promos.length > 0 && <LuxPlusPromoCardCarousel promotions={promos} />}
    </LuxPlusMemberLandingLayout>
  )
}

export default LuxPlusLoggedInLandingPageContent
